import { AuthorizationRequestData } from 'apex-ui-services'
import { uniq } from 'lodash'

export const ACCOUNTS_VIEW: string[] = ['account.read']
export const TRADE_REPORTS: string[] = ['trade_reports.modify', 'trade_reports.read']

export const ALL_REQUESTED_PERMISSIONS: string[] = uniq([...ACCOUNTS_VIEW, ...TRADE_REPORTS])

export const convertToAuthRequest = (permissions: string[]) => {
  return permissions.map(permission => {
    return {
      permission,
    } as AuthorizationRequestData
  })
}
